import { render, staticRenderFns } from "./DiscoverAssets.vue?vue&type=template&id=9e97e79a&scoped=true&"
import script from "./DiscoverAssets.vue?vue&type=script&lang=js&"
export * from "./DiscoverAssets.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverAssets.vue?vue&type=style&index=0&id=9e97e79a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e97e79a",
  null
  
)

export default component.exports